import { AxiosError } from 'axios';
import { notification } from 'antd';

export const handleAPIError = (error, title = 'Error') => {
  let message = 'An error occurred';

  if (typeof error === 'string') {
    message = error;
  } else if (error instanceof AxiosError) {
    const data = error.response?.data;
    if (data?.extra?.response?.message) {
      const messages = data.extra.response.message;
      if (Array.isArray(messages)) {
        message = messages.join(', ');
      } else {
        message = messages;
      }
    } else {
      message = error.response?.data?.message;
    }
  } else if (error instanceof Error) {
    message = error.message;
  }

  console.error(error, title);

  notification.error({
    message: title,
    description: message,
  });
};
